import * as XLSX from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import { setColumnWidth, withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';
import { getPreparedData } from './maping';
import { InitialAndFollowOnPortfolios } from 'src/app/domain/pp/service/PortfolioInitialAndFollowOnCalculation';

export class ValuationBasisTemplate implements ExcelTemplate {

  export(data: InitialAndFollowOnPortfolios): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  };

  private getSheet(exportExcelData: InitialAndFollowOnPortfolios): XLSX.WorkSheet {
    const headersForDisplay = this.getHeadersForDisplay();

    const preparedData = getPreparedData(exportExcelData, headersForDisplay);
    const largeColumns = [0, 3];
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    largeColumns.forEach((index) => setColumnWidth(sheet, index, 26));
    return withHeaderStyling(sheet);
  }

  private getHeadersForDisplay(): string[] {
    return ['Company', 'Last round (name)', 'Last round (date)', 'Days passed', 'Current company value', 'Price per share',
      'Run rate (monthly)', 'Burn rate (monthly)', 'Cash reserve (amount)',
      'Cash reserve (monthly)', 'Annual revenue',
      'Fundraising status', 'Product and market updates', 'Valuation decision'];
  }
}
